import { compose } from 'recompose';

import ContactCreate from './ContactCreate';

const enhance = compose();

export default enhance(ContactCreate);
